import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { msg } from 'api';

export default class InstantShop extends Component {
  static propTypes = {
    addAllInstantShopItems: PropTypes.func.isRequired,
    isSuggestedOrderAvailable: PropTypes.bool.isRequired,
    numberOfItemsInBasket: PropTypes.number.isRequired,
    router: PropTypes.object.isRequired,
  };

  shouldComponentUpdate(nextProps) {
    if (this.props.numberOfItemsInBasket > 0 && nextProps.numberOfItemsInBasket === 0) {
      return false;
    }
    return this.props.numberOfItemsInBasket !== nextProps.numberOfItemsInBasket
      || this.props.isSuggestedOrderAvailable !== nextProps.isSuggestedOrderAvailable;
  }

  renderUnavailableInstantShop = () => (
    <p className="hd-instantShop__info">{msg.suggestedOrder.unavailableUserInfo}</p>
  );

  renderAvailableInstantShop = () => (
    <Fragment>
      <p className="hd-instantShop__info">{msg.suggestedOrder.availableUserInfo}</p>
      <div className="btn-no-margin-wrapper">
        <button
          className="hd-instantShop__viewButton btn-primary"
          onClick={() => this.props.router.push('/webshop/displaySuggestedOrder.do')}
        >
          View items
        </button>
        <button
          className="hd-instantShop__addButton btn-action"
          onClick={this.props.addAllInstantShopItems}
        >
          Add all
        </button>
      </div>
    </Fragment>
  );

  render() {
    const { numberOfItemsInBasket, isSuggestedOrderAvailable } = this.props;
    if (numberOfItemsInBasket > 0) {
      return null;
    }
    return (
      <div className="hd-instantShop__container">
        <h4 className="hd-instantShop__header">Your Instant Shop</h4>
        {
          isSuggestedOrderAvailable
            ? this.renderAvailableInstantShop()
            : this.renderUnavailableInstantShop()
        }
      </div>
    );
  }
}
